import React from 'react';
import './Overview.css';

const Overview = ({ kpis, billingSummary, subscriptions, onSeedBilling, seeding }) => {
  const summary = billingSummary || {
    totalRevenue: '$0',
    mrr: '$0',
    arr: '$0',
    activeSubs: 0,
    trialing: 0,
    churned: 0,
    updatedAt: null,
  };

  return (
    <>
      <div className="overview-header">
        <h2>System Overview</h2>
        {onSeedBilling && (
          <button className="sa-btn ghost" onClick={onSeedBilling} disabled={seeding}>
            {seeding ? 'Seeding...' : 'Seed mock billing'}
          </button>
        )}
      </div>

      <div className="sa-grid">
        {kpis.map((kpi, idx) => (
          <div className="sa-card kpi" key={idx}>
            <p className="kpi-label">{kpi.label}</p>
            <p className="kpi-value">{kpi.value}</p>
          </div>
        ))}
        <div className="sa-card kpi">
          <p className="kpi-label">Total Revenue</p>
          <p className="kpi-value">{summary.totalRevenue || '$0'}</p>
        </div>
        <div className="sa-card kpi">
          <p className="kpi-label">MRR</p>
          <p className="kpi-value">{summary.mrr || '$0'}</p>
        </div>
        <div className="sa-card kpi">
          <p className="kpi-label">Active Subs</p>
          <p className="kpi-value">{summary.activeSubs ?? 0}</p>
        </div>
        <div className="sa-card kpi">
          <p className="kpi-label">Trials</p>
          <p className="kpi-value">{summary.trialing ?? 0}</p>
        </div>
      </div>

      <div className="sa-card billing-block">
        <div className="billing-header">
          <div>
            <p className="kpi-label">Billing Snapshot</p>
            <p className="billing-updated">
              Updated: {summary.updatedAt ? new Date(summary.updatedAt.seconds * 1000).toLocaleString() : 'Mock data'}
            </p>
          </div>
          <div className="billing-arr">
            <span className="kpi-label">ARR</span>
            <span className="kpi-value">{summary.arr || '$0'}</span>
          </div>
        </div>
        <div className="billing-table">
          <div className="billing-head">
            <span>Team/User</span>
            <span>Plan</span>
            <span>Status</span>
            <span>Renews</span>
          </div>
          {(subscriptions || []).slice(0, 6).map((sub) => (
            <div className="billing-row" key={sub.id}>
              <span>{sub.teamId || sub.userId || '-'}</span>
              <span>{sub.planId || 'standard'}</span>
              <span className="billing-status">{sub.status || 'active'}</span>
              <span>{sub.renewsAt ? new Date(sub.renewsAt.seconds * 1000).toLocaleDateString() : '-'}</span>
            </div>
          ))}
          {(subscriptions || []).length === 0 && <div className="sa-empty">No subscription data (mocking).</div>}
        </div>
      </div>
    </>
  );
};

export default Overview;
